import { observer } from 'mobx-react';
import React from 'react';
import AverageLevelChart from './AverageLevelChart';
import averageLevelChartService from '../../services/AverageLevelChartService';

function GlobalAverageLevelChartContainer() {
  return (
    <AverageLevelChart course={averageLevelChartService.course} isFetching={averageLevelChartService.fetch.fetching} />
  );
}

export default observer(GlobalAverageLevelChartContainer);
